import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useGoogleOneTapLogin } from '@react-oauth/google'
import * as Sentry from '@sentry/react'
import { selectAuth } from '@/containers/Login/AuthSelectors'
import { authActions } from '@/containers/Login/AuthSagas'

const HOSTED_DOMAIN = 'selectra.info'

const useExperimentalSsoLogin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(selectAuth)
  const [country, setCountry] = useState('fr')
  const [promptStatus, setPromptStatus] = useState('')

  useGoogleOneTapLogin({
    onSuccess: ({ credential }) =>
      dispatch({ type: authActions.LOGIN_WITH_GOOGLE_CREDENTIAL, credential, navigate, country }),
    onError: () => {
      setPromptStatus('failed')
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('Google One Tap login failed'))
      }
    },
    // Without this the card closes on the first click anywhere on the page, and Google then
    // holds it back for the rest of the session.
    cancel_on_tap_outside: false,
    hosted_domain: HOSTED_DOMAIN,
    use_fedcm_for_prompt: true,
    promptMomentNotification: notification => setPromptStatus(notification.getMomentType()),
  })

  return {
    country,
    error,
    isLoading,
    promptStatus,
    setCountry,
  }
}

export default useExperimentalSsoLogin
